import styled from "styled-components/native";

// ./styled-components
export * from "./styled-components";

// ./types
export * from "./types";

// ./themes
export * from "./themes";

// ./components
export * from "./components";

// ./hooks
export * from "./hooks";

// ./hoc
export * from "./hoc";

// ./utils
export * from "../utils/_collections";

const kitchn = styled;
export default kitchn;
